import { lazy } from "react"
import CalendarView from "../views/calendar-view/calendar-view"
import NewCalendarView from "../views/new-calendar-view/new-calendar-view"
import {
  GESTATIONAL_CALCULATOR_LIST_VIEW,
  GESTATION_CALENDAR_EVENT_VIEW,
  GESTATION_CALENDAR_TEMPLATE_VIEW,
  GESTATION_CALENDAR_TEMPLATE_LIST_VIEW,
  GESTATIONAL_CALCULATOR_VIEW,
  NEW_GESTATION_CALENDAR_EVENT_VIEW,
  NEW_GESTATIONAL_CALCULATOR_VIEW,
} from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllCalendarTemplates = lazy(
  () =>
    import(
      "@/features/gestational-calendar/views/all-calendar-templates/all-calendar-templates"
    ),
)
const AllCalendarsPage = lazy(
  () =>
    import(
      "@/features/gestational-calendar/views/all-calendars-page/all-calendars-page"
    ),
)
const GestationalEventView = lazy(
  () =>
    import(
      "@/features/gestational-calendar/views/calendar-event-view/calendar-event-view"
    ),
)
const GestationCalendarModelsView = lazy(
  () =>
    import(
      "@/features/gestational-calendar/views/calendar-template-view/calendar-template-view"
    ),
)
const NewGestationCalendarEventView = lazy(
  () =>
    import(
      "@/features/gestational-calendar/views/new-gestation-calendar-event/new-gestation-calendar-event"
    ),
)
export const gestationalCalendarRoutes = [
  {
    path: GESTATIONAL_CALCULATOR_LIST_VIEW,
    element: <AllCalendarsPage />,
  },
  {
    path: `${NEW_GESTATIONAL_CALCULATOR_VIEW}/:gender?/:animalId?`,
    element: <NewCalendarView />,
  },
  {
    path: `${GESTATIONAL_CALCULATOR_VIEW}/:calendarId`,
    element: <CalendarView />,
  },
  {
    path: GESTATION_CALENDAR_TEMPLATE_LIST_VIEW,
    element: <AllCalendarTemplates />,
  },
  {
    path: GESTATION_CALENDAR_TEMPLATE_VIEW,
    element: <GestationCalendarModelsView />,
  },
  {
    path: GESTATION_CALENDAR_EVENT_VIEW,
    element: <GestationalEventView />,
  },
  {
    path: NEW_GESTATION_CALENDAR_EVENT_VIEW,
    element: <NewGestationCalendarEventView />,
  },
]

const DESKTOP_GESTATIONAL_CALENDAR_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: gestationalCalendarRoutes,
  },
]

const MOBILE_GESTATIONAL_CALENDAR_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: gestationalCalendarRoutes,
  },
]

export const getGestationalCalendarRoutes = (isDesktop: boolean) => {
  return isDesktop
    ? DESKTOP_GESTATIONAL_CALENDAR_ROUTES
    : MOBILE_GESTATIONAL_CALENDAR_ROUTES
}
